import { Theme } from '@mui/material';
import styled from '@mui/system/styled';

export const AuthWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  paddingTop: '15px',
  '& a': {
    marginLeft: '10px',
    textDecoration: 'none'
  }
});

export const SignInBtn = styled('div')(({ theme }: { theme?: Theme }) => ({
  '& button': {
    backgroundColor: 'hsla(0, 0%, 100%, 0.25)',
    borderColor: theme.palette.primary.contrastText,
    color: theme.palette.primary.contrastText,
    border: '1px solid',
    borderRadius: '3px',
    transition: 'All 0.3s',
    letterSpacing: '0.27px',
    padding: '16px 24px 14px',
    fontWeight: '400',
    marginRight: '-10px',
    '&:hover': {
      backgroundColor: 'hsla(0, 0%, 100%, 1)',
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main
    }
  }
}));

export const RegBtn = styled('div')(({ theme }: { theme?: Theme }) => ({
  '& button': {
    borderRadius: '3px',
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    letterSpacing: '0.3px',
    padding: '16px 24px 14px',
    marginLeft: '9px',
    border: '1px solid transparent',
    fontWeight: '400',
    '&:hover': {
      backgroundColor: '#49c3c1',
      borderColor: '#49c3c1',
      color: theme.palette.primary.contrastText
    }
  }
}));

export const AuthUserName = styled('div')(({ theme }: { theme?: Theme }) => ({
  color: theme.palette.primary.contrastText,
  marginBottom: '5px',
  fontSize: '12px'
}));

export const LoggedInAuthWrapper = styled('div')(
  ({ theme }: { theme?: Theme }) => ({
    display: 'inline-block',
    marginTop: '0',
    marginLeft: '0',
    [theme.breakpoints.up('md')]: {
      marginTop: '10px',
      marginLeft: '50px'
    }
  })
);

// Auth Menu
export const NotificationCount = styled('span')(
  ({ theme, unacknowledged }: { theme?: Theme; unacknowledged?: string }) => ({
    display: 'inline-block',
    color: theme.palette.primary.contrastText,
    backgroundColor: unacknowledged ? 'red' : '#989fad',
    fontSize: '14px',
    marginRight: '11px',
    width: '40px',
    borderRadius: '15px',
    height: '19px',
    paddingTop: '3px',
    textAlign: 'center'
  })
);

// Logo
export const LogoWrapper = styled('div')(({ theme }: { theme?: Theme }) => ({
  width: '100px',
  height: 'auto',
  paddingBottom: '2px',
  paddingRight: '2px',
  '& svg': {
    borderBottomLeftRadius: '6px',
    borderBottomRightRadius: '6px',
    [theme.breakpoints.up('lg')]: {
      '& g:nth-of-type(1)': {
        transform: 'translate(31px, 22px) scale(0.8) !important'
      },
      '& g:nth-of-type(2)': {
        transform: 'translate(22px, 59px) scale(0.68) !important'
      }
    },
    [theme.breakpoints.up('xl')]: {
      '& g:nth-of-type(1)': {
        transform: 'translate(30px, 22px) scale(0.8) !important'
      },
      '& g:nth-of-type(2)': {
        transform: 'translate(21px, 59px) scale(0.68) !important'
      }
    }
  },
  [theme.breakpoints.up('md')]: {
    height: '100px'
  },
  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
    display: 'flex',
    width: '100%'
  }
}));

export const SearchIconWrapper = styled('div')(
  ({
    theme,
    isShowSearchField
  }: {
    theme?: Theme;
    isShowSearchField: boolean;
  }) => ({
    '& .btn-search-icon': {
      visibility: isShowSearchField ? 'hidden' : 'inherit',
      background: 'white',
      color: theme.palette.primary.main,
      borderRadius: '100px',
      ':hover': {
        color: 'white'
      },
      height: '24px',
      width: '24px',
      minWidth: 'auto',
      marginBottom: '1px',

      [theme.breakpoints.up('md')]: {
        height: '36px',
        width: '36px'
      },

      [theme.breakpoints.up('lg')]: {
        marginRight: '1px'
      },

      '& svg': {
        transform: 'scale(0.8)',
        [theme.breakpoints.up('md')]: {
          transform: 'scale(1.28)'
        }
      }
    }
  })
);

export const MenuContainer = styled('span')({
  '& .menu-buttons': {
    marginRight: '3px',
    '& Button': {
      paddingRight: '2px',
      fontWeight: 400,
      '& span': {
        marginLeft: '3px',
        marginTop: '1px',
        '& svg': {
          fontSize: '23px'
        }
      }
    }
  }
});

export const AdvisorSearchOption = styled('span')(
  ({ theme }: { theme?: Theme }) => ({
    verticalAlign: 'middle',
    padding: '4px 15px !important',
    marginBottom: '5px',
    lineHeight: 1,
    minHeight: 'auto !important',
    '& .search-advisors-option-label': {
      fontSize: '14px',
      marginLeft: '10px',
      paddingTop: '2px'
    },

    [theme.breakpoints.up('sm')]: {
      padding: '4px 25px !important',
      '& .search-advisors-option-label': {
        fontSize: '16px'
      }
    }
  })
);
